import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';

import { COMMON_LOGIN_MODAL } from '../utils/constants';

import LoginShield from '../icons/LoginShield';
import LoginCard from '../icons/LoginCard';

import Button from '../Button';

import styles from './EnforceLogin.module.scss';

const pickRandomBlockerImage = () =>
  Date.now() % 2 ? <LoginShield /> : <LoginCard />;

export const EnforceLogin = ({ customImageURL = '' }) => {
  const handleLoginClick = () => {
    Mediator.publish(COMMON_LOGIN_MODAL, {
      initialAction: 'login',
      events: {
        open: {
          eventCategory: 'signup/login modal',
          eventAction: `login button`,
          eventLabel: 'open'
        },
        close: {
          eventCategory: 'signup/login modal',
          eventAction: 'Signup/Login button',
          eventLabel: 'close'
        }
      }
    });
  };

  return (
    <div className={classNames(styles['enforce-login'])}>
      <div
        data-jest="enforce-login-image-default"
        className={classNames(styles['enforce-login__image'])}
      >
        {customImageURL ? (
          <img
            src={customImageURL}
            className={classNames(styles['enforce-login__image'])}
            alt="enforce-login__image"
            data-jest="enforce-login-image-custom"
          />
        ) : (
          pickRandomBlockerImage()
        )}
      </div>

      <div className={classNames(styles['enforce-login__text'])}>
        <h1
          className={classNames(styles['enforce-login__title'])}
          data-jest="enforce-login-title"
        >
          {trans('enforce-login.title')}
        </h1>
        <p
          className={classNames(styles['enforce-login__description'])}
          data-jest="enforce-login-description"
        >
          {trans('enforce-login.description')}
        </p>

        <Button
          className={classNames(styles['enforce-login__button'])}
          size="big"
          onClick={handleLoginClick}
          dataTest="enforceLoginButton"
          data-cy="enforceLoginButton" // TODO: remove eventually (breaking change)
          data-jest="enforce-login-button"
        >
          {trans('login.text')}
        </Button>
      </div>
    </div>
  );
};

EnforceLogin.propTypes = {
  customImageURL: PropTypes.string
};

export default EnforceLogin;
